// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3UnSU","imageUploader":"EGiftCard_imageUploader__1kyFx"};